import { useEffect, useRef } from "react"

const isChromeAndroid = () => {
  return /android/i.test(navigator.userAgent) && !/wv/i.test(navigator.userAgent)
}

const useAdjustBodyHeightWhenResizeOnChromeAndroid = () => {
  const initWindowHeight = useRef(window.innerHeight)

  useEffect(() => {
    if (!isChromeAndroid()) {
      return
    }

    const onResize = () => {
      if (window.innerHeight > initWindowHeight.current) {
        document.body.style.height = "100vh"
      } else {
        document.body.style.height = "100%"
      }
    }

    window.addEventListener("resize", onResize)
    return () => {
      document.removeEventListener("resize", onResize)
    }
  }, [])
}

export default useAdjustBodyHeightWhenResizeOnChromeAndroid
